<script lang="ts">
	import * as m from '$lib/paraglide/messages';
	import { Button } from '$lib/components/ui/button';
	import { Input } from '$lib/components/ui/input';
	import { toast } from 'svelte-sonner';
	import { page } from '$app/state';
	import { trackEvent } from '$lib/services/analytics';

	let email = $state('');
	let isSubmitting = $state(false);

	const navigation = {
		services: [
			{ name: m.custom_development(), href: '/solutions#developpement' },
			{ name: m.product_consulting(), href: '/solutions#consulting' },
			{ name: m.technical_audit(), href: '/solutions#audit-technique' },
			{ name: m.team_training(), href: '/solutions#formation' }
		],
		academy: [
			{ name: m.online_training(), href: '/academy' },
			{ name: m.intensive_bootcamp(), href: '/academy' },
			{ name: m.one_to_one_mentoring(), href: '/academy' },
			{ name: m.free_resources(), href: '/resources' }
		],
		usefullLinks: [
			// { name: m.about(), href: '/#consulting' },
			{ name: m.resources(), href: '/resources' },
			{ name: m.nav_case_studies(), href: '/case-studies' },
			{ name: m.toolbox(), href: '/toolbox' },
			{ name: m.faq(), href: '/faq' },
			{ name: m.contact(), href: '/contact' }
		],
		legal: [
			{ name: m.legal_notices(), href: '/legals' },
			{ name: m.privacy_policy(), href: '/privacy-policy' },
			{ name: m.terms_of_use(), href: '/terms-of-use' },
			{ name: m.rss_feed(), href: '/rss.xml' },
			{ name: m.sitemap_feed(), href: '/sitemap.xml' }
		]
	};

	const socials = [
		{
			name: 'Facebook',
			href: 'https://www.facebook.com/Juslin.Komenan/',
			icon: 'M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-3 7h-1.924c-.615 0-1.076.252-1.076.889v1.111h3l-.238 3h-2.762v8h-3v-8h-2v-3h2v-1.923c0-2.022 1.064-3.077 3.461-3.077h2.539v3z'
		},
		{
			name: 'LinkedIn',
			href: 'https://www.linkedin.com/in/juslin/',
			icon: 'M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z'
		},
		{
			name: 'X(Twitter)',
			href: 'https://x.com/misterjuslin',
			icon: 'M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z'
		},
		{
			name: 'GitHub',
			href: 'https://github.com/juslin03',
			icon: 'M12 0c-6.626 0-12 5.373-12 12 0 5.302 3.438 9.8 8.207 11.387.599.111.793-.261.793-.577v-2.234c-3.338.726-4.033-1.416-4.033-1.416-.546-1.387-1.333-1.756-1.333-1.756-1.089-.745.083-.729.083-.729 1.205.084 1.839 1.237 1.839 1.237 1.07 1.834 2.807 1.304 3.492.997.107-.775.418-1.305.762-1.604-2.665-.305-5.467-1.334-5.467-5.931 0-1.311.469-2.381 1.236-3.221-.124-.303-.535-1.524.117-3.176 0 0 1.008-.322 3.301 1.23.957-.266 1.983-.399 3.003-.404 1.02.005 2.047.138 3.006.404 2.291-1.552 3.297-1.23 3.297-1.23.653 1.653.242 2.874.118 3.176.77.84 1.235 1.911 1.235 3.221 0 4.609-2.807 5.624-5.479 5.921.43.372.823 1.102.823 2.222v3.293c0 .319.192.694.801.576 4.765-1.589 8.199-6.086 8.199-11.386 0-6.627-5.373-12-12-12z'
		},
		{
			name: 'YouTube',
			href: 'https://www.youtube.com/@MrJuslin',
			icon: 'M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z'
		}
	];

	async function handleSubmit(e: Event) {
		e.preventDefault();
		isSubmitting = true;

		try {
			const response = await fetch('/api/newsletter/subscribe', {
				method: 'POST',
				headers: { 'Content-Type': 'application/json' },
				body: JSON.stringify({ email })
			});

			const data = await response.json();

			if (data.success) {
				toast.success('📬 Guide envoyé ! Vérifie ta boîte mail.');
				trackEvent('newsletter_signup_success');
				window.location.href = '/thank-you?from=newsletter';
				email = '';
			} else {
				toast.error(data.message ?? m.form_error_message());
				trackEvent('newsletter_signup_failed');
			}
		} catch (error) {
			console.error(error);
			toast.error(m.form_error_message());
			trackEvent('newsletter_signup_failed', { error: 'Unknown error' });
		} finally {
			isSubmitting = false;
		}
	}
</script>

<footer class="bg-card pt-10 pb-6 sm:pt-12 sm:pb-8 md:pt-14 lg:pt-16">
	<div class="container mx-auto px-4 sm:px-6 md:px-8 lg:px-12 xl:px-16 2xl:px-20">
		<!-- Main Footer Content -->
		<div
			class="mb-8 grid grid-cols-2 gap-6 sm:mb-10 sm:grid-cols-2 sm:gap-8 md:mb-12 md:grid-cols-4 lg:grid-cols-5 lg:gap-10 xl:gap-12"
		>
			<!-- Brand Column -->
			<div class="col-span-2 mb-2 sm:col-span-2 sm:mb-4 md:col-span-4 lg:col-span-1 lg:mb-0">
				<div class="mb-4 flex items-center gap-2 sm:mb-5 sm:gap-3 md:mb-6">
					<div
						class="flex h-8 w-8 items-center justify-center rounded-lg bg-gradient-to-br from-juslin-blue to-juslin-gold sm:h-10 sm:w-10 sm:rounded-xl"
					>
						<span class="text-sm font-black text-juslin-black">JK</span>
					</div>
					<span class="text-lg font-bold text-foreground sm:text-xl"
						>Juslin <span class="text-blue-400">Komenan</span></span
					>
				</div>
				<p
					class="mb-4 max-w-xs text-xs leading-relaxed text-muted-foreground sm:mb-5 sm:text-sm md:mb-6"
				>
					{m.headline_role_and_mission()}
				</p>
				<!-- Social Links -->
				<div class="flex items-center gap-3 sm:gap-4">
					{#each socials as social (social.name)}
						<a
							href={social.href}
							class="group flex h-8 w-8 items-center justify-center rounded-lg bg-muted transition-colors hover:bg-juslin-blue/20 sm:h-10 sm:w-10"
							aria-label="Read more on {social.name}"
						>
							<svg
								class="h-4 w-4 text-muted-foreground transition-colors group-hover:text-blue-400 sm:h-5 sm:w-5"
								fill="currentColor"
								viewBox="0 0 24 24"
							>
								<path d={social.icon} />
							</svg>
						</a>
					{/each}
				</div>
			</div>

			<!-- Services -->
			<div>
				<h3 class="mb-3 text-sm font-semibold text-foreground sm:mb-4 sm:text-base">Offres</h3>
				<ul class="space-y-2 sm:space-y-3">
					{#each navigation.services as item (item.name)}
						<li>
							<a
								href={item.href}
								class="text-xs {page.url.pathname === item.href
									? 'text-blue-400'
									: 'text-muted-foreground'} transition-colors hover:text-blue-400 sm:text-sm"
								aria-label="Read more on {item.name}"
							>
								{item.name}
							</a>
						</li>
					{/each}
				</ul>
			</div>

			<!-- Academy -->
			<div>
				<h3 class="mb-3 text-sm font-semibold text-foreground sm:mb-4 sm:text-base">Academy</h3>
				<ul class="space-y-2 sm:space-y-3">
					{#each navigation.academy as item (item.name)}
						<li>
							<a
								href={item.href}
								class="text-xs {page.url.pathname === item.href
									? 'text-blue-400'
									: 'text-muted-foreground'} transition-colors hover:text-juslin-gold sm:text-sm"
								aria-label="Read more on {item.name}"
							>
								{item.name}
							</a>
						</li>
					{/each}
				</ul>
			</div>

			<!-- Company -->
			<div>
				<h3 class="mb-3 text-sm font-semibold text-foreground sm:mb-4 sm:text-base">
					{m.usefull_links()}
				</h3>
				<ul class="space-y-2 sm:space-y-3">
					{#each navigation.usefullLinks as item (item.name)}
						<li>
							<a
								href={item.href}
								class="text-xs {page.url.pathname === item.href
									? 'text-blue-400'
									: 'text-muted-foreground'} transition-colors hover:text-foreground sm:text-sm"
								aria-label="Read more on {item.name}"
							>
								{item.name}
							</a>
						</li>
					{/each}
				</ul>
			</div>

			<!-- Legal -->
			<div>
				<h3 class="mb-3 text-sm font-semibold text-foreground sm:mb-4 sm:text-base">
					{m.legal()}
				</h3>
				<ul class="space-y-2 sm:space-y-3">
					{#each navigation.legal as item (item.name)}
						<li>
							<a
								href={item.href}
								class="text-xs {page.url.pathname === item.href
									? 'text-blue-400'
									: 'text-muted-foreground'} transition-colors hover:text-foreground sm:text-sm"
								aria-label="Read more on {item.name}"
							>
								{item.name}
							</a>
						</li>
					{/each}
				</ul>
			</div>
		</div>

		<!-- Newsletter Mini -->
		<div class="mb-6 border-t border-border pt-6 sm:mb-8 sm:pt-8">
			<div class="flex flex-col justify-between gap-4 sm:gap-6 md:flex-row md:items-center">
				<div class="text-center md:text-left">
					<h3 class="mb-1 text-sm font-semibold text-foreground sm:text-base">
						{m.newsletter()}
					</h3>
					<p class="text-xs text-muted-foreground sm:text-sm">
						{m.newsletter_description()}
					</p>
				</div>
				<form
					action="#"
					method="POST"
					onsubmit={handleSubmit}
					class="flex w-full flex-col gap-2 sm:flex-row sm:gap-3 md:w-auto"
				>
					<Input
						name="email"
						autocomplete="email"
						type="email"
						bind:value={email}
						aria-label={m.your_email_address()}
						placeholder={m.email_placeholder()}
						required
						class="h-10 rounded-full border-border bg-muted text-foreground placeholder:text-muted-foreground focus:border-juslin-blue focus:ring-juslin-blue/20 sm:h-11 md:h-12"
					/>
					<Button
						size="lg"
						type="submit"
						disabled={isSubmitting}
						class="h-10 w-full cursor-pointer rounded-full bg-juslin-blue px-4 text-xs font-semibold text-white shadow-xl transition-all transition-colors hover:scale-105 hover:bg-juslin-blue/90 hover:shadow-2xl sm:h-11 sm:px-6 sm:text-sm md:w-48"
					>
						{#if isSubmitting}
							<svg
								class="mr-2 -ml-1 h-4 w-4 animate-spin text-juslin-black sm:mr-3 sm:h-5 sm:w-5"
								xmlns="http://www.w3.org/2000/svg"
								fill="none"
								viewBox="0 0 24 24"
							>
								<circle
									class="opacity-25"
									cx="12"
									cy="12"
									r="10"
									stroke="currentColor"
									stroke-width="4"
								></circle>
								<path
									class="opacity-75"
									fill="currentColor"
									d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
								></path>
							</svg>
							{m.form_sending_state()}
						{:else}
							{m.subscribe()}
						{/if}
					</Button>
				</form>
			</div>
		</div>

		<!-- Bottom Bar -->
		<div
			class="flex flex-col items-center justify-between gap-3 border-t border-border pt-6 sm:gap-4 sm:pt-8 md:flex-row"
		>
			<p class="text-center text-xs text-muted-foreground sm:text-sm md:text-left">
				{m.footer_rights({ start: 2018, year: new Date().getFullYear() })}
			</p>
			<p class="text-center text-xs text-muted-foreground sm:text-sm md:text-right">
				{m.powered_by({ name: 'Juslin' })}
			</p>
		</div>
	</div>
</footer>
